import React from 'react'

export const NextIcon = () => {
    return (

        <svg xmlns="http://www.w3.org/2000/svg" width="70%" height="100%" viewBox="0 0 16 16" fill="currentColor">
            <path d="M1 8L15 8M15 8L8 1M15 8L8 15" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}